import { createPortal } from "react-dom";
import { SideModal } from "shared";
import { CompanyMyType } from "types/CompanyTypes";
import "./TransactionsSideModal.scss";
import TransactionsTable from "./components/TransactionsTable";
import { useGetMe } from "hooks/auth";
import { SharesByCompanyType } from "types/SharesTypes";
import { Button } from "shared";
import { isDesktop, formatNumber } from "utils";
import { useEffect } from "react";
import { useGetMyCompanies } from "hooks/companies";

interface TransactionsSideModalProps {
  isOpen: boolean;
  onClose: () => void;
  company: CompanyMyType | null;
  setEditTransaction: (company: SharesByCompanyType) => void;
  onAddTransactionClick: () => void;
  isArchived?: boolean;
  isOwn?: boolean;
  blurRestrictedData?: boolean;
}

const TransactionsSideModal: React.FC<TransactionsSideModalProps> = ({
  isOpen,
  onClose,
  company,
  setEditTransaction,
  onAddTransactionClick,
  isArchived = false,
  isOwn = false,
  blurRestrictedData = false,
}) => {
  const client =
    (company as any)?.owner ??
    (company && (company as any).shares && (company as any).shares[0]
      ? (company as any).shares[0]?.user
      : null);
  const { data: authorizedUser } = useGetMe();
  const isAdmin = authorizedUser?.role === "admin";

  const { data: freshCompanies, refetch: refetchCompanies } = useGetMyCompanies(
    {
      origin: company?.origin ?? "other",
      enabled: false,
    },
  );

  useEffect(() => {
    if (isOpen && company) {
      refetchCompanies();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const currentSharesCount =
    freshCompanies?.find((c) => c.id === company?.id)?.sharesCount ??
    company?.sharesCount;

  return createPortal(
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Lista transakcji"
      subtitle={
        isAdmin ? (
          <>
            <p>
              <b>Spółka:</b> {company?.name || "-"} | <b>Klient:</b>{" "}
              {client?.name || "-"}
            </p>
            <p className="transactions-side-modal__counter">
              Obecna ilość sztuk:{" "}
              <b>
                {currentSharesCount != null
                  ? formatNumber(currentSharesCount)
                  : "—"}
              </b>
            </p>
          </>
        ) : (
          <>
            <p>
              <b>Spółka:</b> {company?.name || "-"}{" "}
            </p>
            <p className="transactions-side-modal__counter">
              Obecna ilość sztuk:{" "}
              <b>
                {currentSharesCount != null
                  ? formatNumber(currentSharesCount)
                  : "—"}
              </b>
            </p>
          </>
        )
      }
      className="company-info-modal wide"
    >
      <>
        {!isArchived && !blurRestrictedData && (
          <Button
            className="button--rounded company-info-modal__button"
            onClick={onAddTransactionClick}
            label="Dodaj transakcję  +"
            styleType={isDesktop() ? undefined : "primary"}
          />
        )}
        <TransactionsTable
          isAdmin={isAdmin}
          company={company}
          setEditTransaction={setEditTransaction}
          isOwn={isOwn}
        />
      </>
    </SideModal>,
    document.body,
  );
};

export default TransactionsSideModal;
